import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the filter categories products view.
 * @extends JetView
 */
export default class FilterCategoriesProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing input fields for filtering
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                            invalidMessage: _('ID is required'),
                        },
                        {
                            view: 'richselect',
                            name: 'Categorie',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'Categorie',
                            options: [],
                        },
                        {
                            view: 'combo',
                            name: 'Product',
                            localId: 'product:combo',
                            label: _('Productos'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    // Data feed function for product selection
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Second left section for activation status
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        { id: 'grav2', gravity: 2 },
                    ],
                },
            ],
        };

        // Upper section for the main filter inputs
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section for the activation status
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 70 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button',
                            value: _('Añadir Categoría Producto'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 230,
                            minWidth: 220,
                            hidden: !devConfig.getPermAction('categoriesProductsAdd', 'Add'),
                            css: 'prm-categoriesProductsAdd',
                            click: () => {
                                this.app.callEvent('addCategorieProduct:button', [[]]);
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear();
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues();
                                this.app.callEvent('categoriesProducts:filter', [filterdata]);
                                $$('b1').collapse();
                                $$('a5').scrollTo(100, 0);
                            },
                        },
                    ],
                },
            ],
        };

        // Main accordion section for filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and fetches initial data.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide();
                $$('grav2').hide();
            }
        });

        // Fetch categories for the richselect options
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Categories/GetCategories', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text);
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].id = resp.data[i].Id;
                        resp.data[i].value = resp.data[i].Description;
                    }
                    $$('Categorie').define('options', resp.data);
                },
            });
    }
}

// FILE DOCUMENTED
